<script setup>
import { useNotificationStore } from '@/stores/NotificationStore.js'
const notificationStore = useNotificationStore()

const emit = defineEmits(['deleted'])

const props = defineProps({
    selectedLeads: {
        type: Array,
        required: false,
        default: () => []
    }
})

const deleteAll = async () => {
    const leadIds = props.selectedLeads.map(lead => lead.id)

    const res = await axios.post(route('crm.leads.multiDelete'), {
        lead_ids: leadIds
    });

    notificationStore.addNotification({
        type: res.data.has_warning ? 'warning' : 'success',
        title: res.data.message,
        dismissAfter: 5000,
    })

    emit('deleted')
}

</script>
<template>
    <div>
        <p>
            <mf-translate domainkey="crm:leadsMultiDelete.aboutToDelete" :args="{count: selectedLeads.length}"></mf-translate>
        </p>

        <div class="mb-4">
            <ul class="-mx-4 md:-mx-6 px-4 md:px-6 bg-gray-100 border-y border-y-gray-300 py-1">
                <li
                    v-for="(lead, index) in selectedLeads"
                    :key="index"
                    class="-mx-4 md:-mx-6 px-4 md:px-6 py-1 first:border-t-0 border-t border-t-gray-200"
                >
                    {{ lead.name }}
                </li>
            </ul>
        </div>

        <div class="text-center">
            <p>
                <mf-translate domainkey="crm:leadsMultiDelete.cannotBeUndone"></mf-translate>
            </p>
            <button-danger
                @click="deleteAll"
            >
                <mf-translate domainkey="crm:leadsMultiDelete.deleteAll"></mf-translate>
            </button-danger>
        </div>
    </div>
</template>
